export default discountCode => {
  // const { discountCode } = this.state
  switch (discountCode) {
    case 'saxob18':
      return [
        {
          id: 'combo2hoursPlusDrinks2pax',
          cashOff: 195,
          currency: 'DKK'
        },
        {
          id: 'combo2hoursPlusWine2pax',
          cashOff: 195,
          currency: 'DKK'
        },
      ]
    case 'Turbo10':
      return [
        {
          id: 'passAnnualAdultFull',
          cashOff: 249.5,
          currency: 'DKK'
        },
        {
          id: 'passAnnualChildFull',
          cashOff: 174.5,
          currency: 'DKK'
        },
        {
          id: 'passAnnualAdultWeekdays',
          cashOff: 149.5,
          currency: 'DKK'
        },
        {
          id: 'passAnnualChildWeekdays',
          cashOff: 104.5,
          currency: 'DKK'
        },
        {
          id: 'passAnnualAdultAdvantage',
          cashOff: 79.5,
          currency: 'DKK'
        },
        {
          id: 'passAnnualChildAdvantage',
          cashOff: 52.5,
          currency: 'DKK'
        }
      ]
    default:
      return []
  }
}